import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
function StatsSummary(props) {
    const {stats_data, wanted_data, is_premium} = props
    let list = [];

    Object.keys(stats_data).forEach((item, index) => {
        let count = stats_data[item].reduce((a,b) => a+b);
        if (item !== 'date' && count !== 0) {
            list.push(
                <tr key={index}className="summary-item">
                    <td className="summary-name">{wanted_data[item]}:&nbsp;</td>
                    <td className="summary-value">{count}</td>
                </tr>
            )
        }
    })

    return(
        <div className="summary-content">
            <table className="summary col-sm-5">
                <tbody>
                {list}
                </tbody>
            </table>
            {is_premium === false ?
            <div className="statistics-box statistics-box-second">
                <div className="content">
                <h2>Szukasz więcej danych?</h2>
                <p>Pełna statystyka dostępna jest dla konta Premium.<br/>
                    Monitoruj wszystkie dane dotyczące Twojego profilu w serwisie, m.in.:</p>
                <ul>
                    <li><FontAwesomeIcon icon={faChevronRight}/>pobrania Twojego nr telefonu</li>
                    <li><FontAwesomeIcon icon={faChevronRight}/>pobrania adresu e-mail</li>
                    <li><FontAwesomeIcon icon={faChevronRight}/>wizyty na Twojej stronie www</li>
                </ul>
                </div>
                <a href="/prawnik-portfel/">
                    Wybieram konto Premium
                </a>
            </div> : null }
        </div>
    )
}

export default StatsSummary